module.exports = __webpack_public_path__ + "static/img/shehuiMb.424a938.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/shehuiMb.jpg
// module id = MYvN
// module chunks = 1